import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {APIError} from 'data/errors/api-error';
import {
	CommunicationsParams,
	CommunicationsResponseModel,
	GetCommunications,
} from 'domain/usecases/private/communications/get-communications';

export class RemoteGetCommunications implements GetCommunications {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<CommunicationsResponseModel>,
	) {}

	async get({signal}: CommunicationsParams): Promise<CommunicationsResponseModel> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'get',
			signal,
		});

		switch (httpResponse.status) {
			case HttpStatusCode.ok:
			case HttpStatusCode.created:
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
